/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Giveaways_ReadInputs */



/**
* | output |
* | --- |
* | "See giveaways, their entries and winners" |
*
* @param {Perm_Product_Giveaways_ReadInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_giveaways_read = /** @type {((inputs?: Perm_Product_Giveaways_ReadInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Giveaways_ReadInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеть розыгрыши, их участников и победителей")
	return /** @type {LocalizedString} */ ("See giveaways, their entries and winners")
});